import React, { useEffect, useState } from "react";
import { Badge, Card, Form, Label, Spinner } from "reactstrap";
import { BiEdit, BiMinus, BiPlus } from "react-icons/bi";
import { useForm } from "react-hook-form";
import Required from "../../myComponents/validate/Required";
import ImageUpload from "../../myComponents/form/ImageUpload";
import useLogout, { ValidateImg, ValidateImgWithSize, ValidateImgWithSizeVIPbanner } from "../../utils/Utils";
import ViewImage from "../../myComponents/modals/ViewImage";
import Select from "react-select";
import MyDataTable from "../../myComponents/DataTable/MyDataTable";
import ConfirmModal from "../../myComponents/modals/ConfirmModal";
import { toast } from "react-toastify";
import { decrypt, decryptFormData, encrypt, encryptFormData } from "../../utils/Encrypt";
import {
  addHomeVIPBannerAPI,
  getHomeVIPBannerListAPI,
  getVIPBannerEditAPI,
  statusUpdateVIPBannerAPI,
} from "../../api/banner";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
const VIPBanner = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [mode, setMode] = useState("Add");
  const [data, setData] = useState([]);
  const userData = JSON.parse(localStorage.getItem("userDetail"));
  const IMAGE_BASE_URL = localStorage.getItem("IMAGE_BASE_URL");
  const [column, setColumn] = useState([
    {
      name: "Order",
      selector: (row) => row?.order,
      sortable: true,
    },
    {
      name: "Name (en)",
      selector: (row) => row?.name,
      sortable: true,
    },
    {
      name: "Name (hn)",
      selector: (row) => row?.hn_name,
      sortable: true,
    },
    {
      name: "Designation (en)",
      selector: (row) => row?.designation,
      sortable: true,
      wrap: true,
    },
    {
      name: "Designation (hn)",
      selector: (row) => row?.hn_designation,
      sortable: true,
      wrap: true,
    },
    {
      name: "Image",
      selector: (row) => (
        <div onClick={() => handleImageOpenPreview(`${IMAGE_BASE_URL}` + row?.image)}>
          <img style={{ width: "50px" }} src={`${IMAGE_BASE_URL}` + row.image} />
        </div>
      ),
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status ? "success" : "danger"}`}>{row.status ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
            {" "}
            <Icon name="edit" />
          </Button>
          {/* <Button outline color={`danger`} size={`xs`} onClick={() => handleDelete(row)}>
              {" "}
              <Icon name="trash"></Icon>
            </Button> */}
        </div>
      ),
    },
  ]);
  const logout = useLogout();
  const handleToggleStatus = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };
  // Modal Image Preview
  const [imageOpen, setImageOpen] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      image_url: null,
      emails: [{ value: "" }], // Ensures one default email field
      phones: [{ value: "" }], // Ensures one default phone field
    },
  });

  useEffect(() => {
    getBannerData();
  }, []);
  const getBannerData = () => {
    const data = {};
    getHomeVIPBannerListAPI(data)
      .then((res) => {
        // decrypt data
        const status = decrypt(res.data.status);
        if (status === "success") {
          const decryptedResponse = decrypt(res.data.data.tableData);
          toast.success(res.data.message);
          setData(decryptedResponse);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(!isOpen);
    setMode("Edit");
    setValue("id", row.id); // Add this for consistent `formData` structure
    setValue("image_alt", row.name);
    setValue("image_alt_hn", row.hn_name);
    setValue("designation_en", row.designation);
    setValue("designation_hn", row.hn_designation);
    setValue("order", row.order);
    setValue("image-menu", row.image);
    setValue("image_url", `${IMAGE_BASE_URL}` + row?.image);
    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: row.status,
    });
  };

  const onFormSubmit = async (data) => {
    const formData = new FormData();
    formData.append("name", data.image_alt);
    formData.append("hn_name", data.image_alt_hn);
    formData.append("designation", data.designation_en);
    formData.append("hn_designation", data.designation_hn);
    formData.append("order", data.order);
    formData.append("status", data.status.value);
    formData.append("module", "vip-banner-module");
    const newFd = new FormData();
    if (mode == "Edit") {
      formData.append("id", watch("id"));
    }
    const encryptedData = await encryptFormData(formData);
    newFd.append("zero", encryptedData);
    if (watch("image_url") == null) {
      newFd.append("image", data?.image[0]);
    } else {
      newFd.append("image", data?.image);
    }
    if (mode === "Add") {
      addHomeVIPBannerAPI(newFd)
        .then((res) => {
          const status = decrypt(res.data.status);
          if (status == "success") {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getBannerData();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
    if (mode === "Edit") {
      for (let [key, value] of newFd.entries()) {
        console.log(`${key}:`, value);
      }

      getVIPBannerEditAPI(newFd)
        .then((res) => {
          const status = decrypt(res.data.status);
          if (status == "success") {
            toast.success(res.data.message);
            getBannerData();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
  };
  const handleImageChange = (e, errorInput, url) => {
    const file = e.target.files[0];
    if (file) {
      ValidateImgWithSizeVIPbanner(file, (isValid, message) => {
        if (isValid) {
          setValue(errorInput, file); // Set as File object, not string
          const imageUrl = URL.createObjectURL(file);
          setValue(url, imageUrl);
          trigger(errorInput);
          setTimeout(() => clearErrors(errorInput), 100);
        } else {
          setError(errorInput, {
            type: "manual",
            message: message,
          });
          e.target.value = "";
        }
      });
    } else {
      setValue(errorInput, "");
    }
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const handleStatusChange = (selectedOption) => {
    setValue("status", selectedOption || "");
    trigger("status");
  };

  const confirmStatusChange = () => {
    const updatedStatus = selectedRow.status === true ? true : false;

    const formObject = {
      id: selectedRow.id,
      status: updatedStatus,
    };

    const encryptedData = encrypt(formObject);
    const encryptData = {
      zero: encryptedData,
    };
    statusUpdateVIPBannerAPI(encryptData)
      .then((res) => {
        // decrypt data
        const status = decrypt(res.data.status);
        if (status === "success") {
          getBannerData();
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => console.error("Error updating status:", err));

    setShowModal(false);
  };

  const handleImageChange1 = (e, imageField, imageUrlField) => {
    const file = e.target.files[0];
    if (!file) return;

    const maxSizeMB = 1;
    if (file.size > maxSizeMB * 1024 * 1024) {
      setError(imageField, {
        type: "manual",
        message: "Image must be less than 1MB",
      });
      return;
    }

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.src = objectUrl;

    img.onload = () => {
      if (img.width !== 1920 || img.height !== 566) {
        setError(imageField, {
          type: "manual",
          message: "Image dimensions must be exactly 1920x566 pixels", // fixed typo
        });
        return;
      }

      // ✅ All validations passed — only now we clear errors and set values
      clearErrors(imageField);
      setValue(imageField, file);
      setValue(imageUrlField, objectUrl);
    };

    img.onerror = () => {
      setError(imageField, {
        type: "manual",
        message: "Invalid image file",
      });
    };
  };

  return (
    <>
      <Head title={"Manage Banner"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage VIP Banner"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen(!isOpen);
                    setMode("Add");
                    reset();
                  }}
                >
                  {<Icon name={isOpen ? "minus" : "plus"} />}
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className="g-gs ">
            <>
              {isOpen && (
                <PreviewAltCard className="">
                  <Form onSubmit={handleSubmit(onFormSubmit)}>
                    <Row className={`g-gs`}>
                      {/*Image Name */}
                      <Col md="4" sm="3" xxl="3">
                        <div className="form-group">
                          <Label className="form-label" htmlFor="image_alt">
                            {"Name (English)"}
                            <Required />
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              placeholder={"Enter Name in English"}
                              type="text"
                              id="image_alt"
                              {...register("image_alt", {
                                required: {
                                  value: true,
                                  message: "Name (english) is required",
                                },
                                // pattern: {
                                //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                                //   message: "Only alphabets are allowed",
                                // },
                                minLength: {
                                  value: 3,
                                  message: "Name (english) must be at least 2 characters long",
                                },
                                maxLength: {
                                  value: 100,
                                  message: "Name (english) cannot exceed 100 characters",
                                },
                              })}
                              className="form-control"
                              value={watch("image_alt")}
                              onChange={(e) => {
                                // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                                // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                setValue("image_alt", e.target.value);
                                trigger("image_alt"); // Trigger validation
                              }}
                              // onInput={(e) => {
                              //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                              // }}
                            />
                            {errors.image_alt && <span className="invalid">{errors?.image_alt?.message}</span>}
                          </div>
                        </div>
                      </Col>{" "}
                      {/*Image Name HN */}
                      <Col md="4" sm="3" xxl="3">
                        <div className="form-group">
                          <Label className="form-label" htmlFor="image_alt_hn">
                            {"Name (Hindi)"}
                            <Required />
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              placeholder={"Enter Name in hindi"}
                              type="text"
                              id="image_alt_hn"
                              {...register("image_alt_hn", {
                                required: {
                                  value: true,
                                  message: "Name (hindi) is required",
                                },
                                // pattern: {
                                //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                                //   message: "Only alphabets are allowed",
                                // },
                                minLength: {
                                  value: 3,
                                  message: "Name (hindi) must be at least 2 characters long",
                                },
                                maxLength: {
                                  value: 100,
                                  message: "Name (hindi) cannot exceed 100 characters",
                                },
                              })}
                              className="form-control"
                              value={watch("image_alt_hn")}
                              onChange={(e) => {
                                // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                                // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                setValue("image_alt_hn", e.target.value);
                                trigger("image_alt_hn"); // Trigger validation
                              }}
                              // onInput={(e) => {
                              //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                              // }}
                            />
                            {errors.image_alt_hn && <span className="invalid">{errors?.image_alt_hn?.message}</span>}
                          </div>
                        </div>
                      </Col>{" "}
                      {/*Image Designation */}
                      <Col md="4" sm="3" xxl="3">
                        <div className="form-group">
                          <Label className="form-label" htmlFor="image_alt">
                            {"Designation (English)"}
                            <Required />
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              placeholder={"Enter Designation (english)"}
                              type="text"
                              id="designation_en"
                              {...register("designation_en", {
                                required: {
                                  value: true,
                                  message: "Designation (english) is required",
                                },
                                // pattern: {
                                //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                                //   message: "Only alphabets are allowed",
                                // },
                                minLength: {
                                  value: 3,
                                  message: "Designation (english) must be at least 2 characters long",
                                },
                                maxLength: {
                                  value: 100,
                                  message: "Designation (english) cannot exceed 100 characters",
                                },
                              })}
                              className="form-control"
                              value={watch("designation_en")}
                              onChange={(e) => {
                                // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                                // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                setValue("designation_en", e.target.value);
                                trigger("designation_en"); // Trigger validation
                              }}
                              // onInput={(e) => {
                              //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                              // }}
                            />
                            {errors.designation_en && (
                              <span className="invalid">{errors?.designation_en?.message}</span>
                            )}
                          </div>
                        </div>
                      </Col>{" "}
                      {/*Image Designation HN */}
                      <Col md="4" sm="3" xxl="3">
                        <div className="form-group">
                          <Label className="form-label" htmlFor="designation_hn">
                            {"Designation (Hindi)"}
                            <Required />
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              placeholder={"Enter Designation in hindi"}
                              type="text"
                              id="designation_hn"
                              {...register("designation_hn", {
                                required: {
                                  value: true,
                                  message: "Designation (hindi) is required",
                                },
                                // pattern: {
                                //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                                //   message: "Only alphabets are allowed",
                                // },
                                minLength: {
                                  value: 3,
                                  message: "Designation (hindi) must be at least 2 characters long",
                                },
                                maxLength: {
                                  value: 100,
                                  message: "Designation (hindi) cannot exceed 100 characters",
                                },
                              })}
                              className="form-control"
                              value={watch("designation_hn")}
                              onChange={(e) => {
                                // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                                // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                setValue("designation_hn", e.target.value);
                                trigger("designation_hn"); // Trigger validation
                              }}
                              // onInput={(e) => {
                              //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                              // }}
                            />
                            {errors.designation_hn && (
                              <span className="invalid">{errors?.designation_hn?.message}</span>
                            )}
                          </div>
                        </div>
                      </Col>{" "}
                      {/* Banner Order */}
                      <Col md="2" sm="3" xxl="3">
                        <div className="form-group">
                          <Label className="form-label" htmlFor="order">
                            {"Order"}
                            <Required />
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              placeholder={"Enter order"}
                              type="text"
                              id="order"
                              {...register("order", {
                                required: "Order is required",
                                pattern: {
                                  value: /^[1-9][0-9]{0,2}$/,
                                  message: "Enter a Order greater than 0 and up to 100",
                                },
                                minLength: {
                                  value: 1,
                                  message: "Order must be at least 1 character long",
                                },
                                validate: (value) => (value >= 1 && value <= 100) || "Order must be between 1 and 100",
                              })}
                              className="form-control"
                              onChange={(e) => {
                                e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                setValue("order", e.target.value);
                                trigger("order"); // Trigger validation
                              }}
                              value={watch("order")}
                            />
                            {errors.order && <span className="invalid">{errors?.order?.message}</span>}
                          </div>
                        </div>
                      </Col>{" "}
                      <Col md={`2`}>
                        <div className="form-group">
                          <Label className="from-label" htmlFor="status">
                            Status
                          </Label>
                          <div className="form-control-wrap">
                            <Select
                              className=""
                              id="status"
                              options={[
                                { value: true, label: "Active" },
                                { value: false, label: "InActive" },
                              ]}
                              {...register("status", {
                                required: "Please select status",
                              })}
                              onChange={handleStatusChange}
                              value={watch("status")}
                            />
                            {errors.status && (
                              <span
                                className="invalid"
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors?.status?.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md={`3`}>
                        <ImageUpload
                          handleImageChange={handleImageChange}
                          watch={watch}
                          register={register}
                          errors={errors}
                          setValue={setValue}
                          setError={setError}
                          clearErrors={clearErrors}
                          handleImageOpenPreview={handleImageOpenPreview}
                          image="image"
                          image_url="image_url"
                          validate={true} // Enable validation
                          label={"Upload Image"}
                          design={false}
                        />
                      </Col>
                    </Row>
                    <Col md="2" className={``}>
                      <div className="form-group" style={{ marginTop: "31px" }}>
                        <Button disabled={isLoading} color="primary" size="md">
                          {isLoading ? <Spinner size="sm" color="primary" /> : mode == "Add" ? "Save" : "Update"}
                        </Button>
                      </div>
                    </Col>
                  </Form>
                </PreviewAltCard>
              )}
            </>
            <MyDataTable data={data} columns={column} title={"Banner"} isLoading={isLoading} />
          </Row>
        </Block>
      </Content>

      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
      {/* Confirmation Modal */}
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={selectedRow?.status}
      />
    </>
  );
};

export default VIPBanner;
